import { atom } from 'jotai';
import { BATCH_SETTINGS } from '../batch-review/constants';
import type { BatchSettingsT } from '../batch-review/types';
export const batchSettingsAtom = atom<{ [key in BatchSettingsT]: boolean }>(Object.values(BATCH_SETTINGS).reduce((acc, key) => {
  acc[key] = false;
  return acc;
}, ({} as Record<BatchSettingsT, boolean>)));